
import { defineComponent } from "vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import ApiService from "@/core/services/ApiService";
import Pagination from "@/components/widgets/custom/Pagination.vue";

import { useToast } from "vue-toastification";
import Switch from "@/components/widgets/custom/Switch.vue";
// Import loading overlay
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// end import loading overlay

interface FeatureData {
  _id: string;
  feature_name: string;
  release_date: string;
  description: string;
  programmer: string;
  feature_location: string;
  feature_status: string;
  isDelete: string;
}

interface ModuleDetail {
  moduleKey: string;
  moduleDescription: string;
  status: string;
}

interface MasterFiturData extends FeatureData {
  module_detail: ModuleDetail[];
  isActive?: boolean;
}

export default defineComponent({
  name: "MasterFitur",
  components: {
    Switch,
    Loading,
    Pagination,
  },
  props: {
    widgetClasses: String,
  },

  data() {
    return {
      // loading overlay setting
      isLoading: false,
      fullPage: true,
      isColor: "#007BFF",
      isBackgroundColor: "#A3A3A3",
      isOpacity: 0.5,
      // end loading overlay setting

      tableData: [] as MasterFiturData[],
      paging: {
        page: 0,
        totalPages: 0,
        size: 10,
        totalElements: 0,
        perPageOptions: [10, 25, 50, 100],
      },

      name: "",
      showFilter: false,
      timer: 0,
    };
  },

  beforeMount() {
    this.getData(this.paging.size, this.paging.page);
  },

  computed: {
    to() {
      let highBound = this.from + this.paging.size;
      if (this.paging.totalElements < highBound) {
        highBound = this.paging.totalElements;
      }
      return highBound;
    },
    from() {
      return this.paging.size * this.paging.page;
    },
  },

  methods: {
    getData(size, page) {
      // loading overlay tampil
      this.isLoading = true;
      const toast = useToast();

      let search = "";
      if (this.name) {
        search = "feature_name=" + this.name + "&";
      } else {
        search;
      }

      ApiService.getWithoutSlug(
        "crmv2/main_feature/feature-master/all?" +
          search +
          "&" +
          "page=" +
          page +
          "&size=" +
          size +
          "&sort=feature_name&dir=1"
      )
        .then(({ data }) => {
          this.tableData = data.content.map((item) => {
            return {
              ...item,
              isActive: !item.isDelete ? "Active" : "Inactive",
            };
          });
          this.paging.page = data.page;
          this.paging.size = data.size;
          this.paging.totalElements = data.totalElements;
          this.paging.totalPages = data.totalPages;

          this.isLoading = false;
        })
        .catch((e) => {
          console.log(e);
          if (e.response.status == 401) {
            toast.error(e.response.data.detail);
            this.$router.push("/sign-in");
            this.isLoading = false;
          } else {
            toast.error(e.response.data.detail);
            this.isLoading = false;
          }
        });
    },

    handleDelete(index, item) {
      Swal.fire({
        title: "Apakah Anda Yakin ?",
        text: `Data yang telah dihapus tidak dapat dikembalikan !`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Ya, hapus !",
        cancelButtonText: "Batal",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteRow(item);
        }
      });
    },
    deleteRow(item) {
      const toast = useToast();

      ApiService.delete("crmv2/main_feature/feature-master/" + item._id)
        .then((res) => {
          toast.success("Hapus Berhasil");

          this.getData(this.paging.size, this.paging.page);
        })

        .catch((error) => {
          toast.error("Gagal Hapus");
        });
    },

    range(min, max) {
      const arr: any[] = [];
      for (let i = min; i <= max; i++) {
        arr.push(i);
      }
      return arr;
    },

    changePage(item) {
      const page = item - 1;
      this.getData(this.paging.size, page);
    },
    nextPage() {
      const page = parseInt(this.paging.page.toString()) + 1;
      this.getData(this.paging.size, page);
    },
    prevPage() {
      console.log(this.paging.page);
      const page = parseInt(this.paging.page.toString()) - 1;
      this.getData(this.paging.size, page);
    },
    changePageSize() {
      const page = this.paging.page;
      this.getData(this.paging.size, page);
    },

    //event
    eventDelaySearch() {
      clearTimeout(this.timer); //this timer 0 - set 0 atau clear jika ada input lagi
      this.timer = setTimeout(() => {
        const page = this.paging.page;
        this.getData(this.paging.size, page);
      }, 1000);
    },
    showHideFilter() {
      this.showFilter = !this.showFilter;
    },
  },
});
